module.exports = __webpack_public_path__ + "static/media/funding-icon.80bd5d56.png";